:host,
:host *,
:host *::after,
:host *::before {
  box-sizing: border-box;
}

:host {
  display: flex;
  flex: 1;
}

#button {
  min-height: 48px;
  width: 100%;
  max-width: 320px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--grid-border-radius-button);
  cursor: pointer;
  transition: background-color var(--duration-fast) var(--curve-expressive-ease-in-out), border-color var(--duration-fast) var(--curve-expressive-ease-in-out);
  text-decoration: none;
}

#button:hover {
  transition: background-color var(--duration-xxfast) var(--curve-simple-ease-out), border-color var(--duration-xxfast) var(--curve-simple-ease-out);
}

.filled {
  background: var(--grid-action-primary);
  border: 1px solid var(--grid-border-action-primary);
}

.filled:hover {
  background: var(--grid-action-primary-hover);
  border-color: var(--grid-border-action-primary-hover);
}

.ghost {
  border: 1px solid var(--grid-border-action-primary-ghost);
  background: transparent;
}

.ghost:hover {
  border-color: var(--grid-border-action-primary-ghost-hover);
}

.ghost:hover #label {
  color: var(--grid-content-on-action-primary-ghost-hover);
}

#label {
  font: var(--label-button);
  cursor: pointer;
}

.filled #label {
  color: var(--grid-content-on-action-primary);
}

.ghost #label {
  color: var(--grid-content-on-action-primary-ghost);
}

@media screen and (max-width: 989px) {
  #button {
    width: unset;
    max-width: unset;
    flex: 1;
    white-space: nowrap;
    padding: 8px 14px;
  }
}
